import { render, staticRenderFns } from "./EditGeneric.vue?vue&type=template&id=e87ad234&"
import script from "./EditGeneric.vue?vue&type=script&lang=js&"
export * from "./EditGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports